import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	XhrStatus,
	Callout
} from '@bosch/bt-ui';

import './RestfulCallout.css';
import withErrorHandler from './ErrorHandler';

const RestfulCallout = (props) => {
	const {
		status,
		response,
		returnObj,
		hideSuccess
	} = props;

	return (
		<div id="restful-callout">
			{
				status === XhrStatus.Error ?
					// ["success","error","warning","info","neutral"].
					<Callout type="error">
						{(response) ? response.status + ' ' + response.statusText : 'Network Problem, Please Contact Admin!'} : {(returnObj) ? returnObj.message : 'Please Contact Admin!'}
					</Callout>
					:
					(returnObj) ?
						(returnObj.status !== 'Success' && returnObj.status !== 'Accepted') ?
							<Callout type="warning">
								{returnObj.status} : {returnObj.message ? returnObj.message : JSON.stringify(returnObj.data)}
							</Callout>
							:
							!hideSuccess &&
							<Callout type="success">
								{returnObj.status} : {returnObj.message ? returnObj.message : (typeof returnObj.data == 'string' ? returnObj.data : 'Operation Done.')}
							</Callout>
						:
						<div></div>
			}
		</div>
	);
}

export default withErrorHandler(RestfulCallout);